import { motion } from "framer-motion";
import { FaEnvelope } from "react-icons/fa";
import ContactForm from "./ContactForm";
import ContactInfo from "./ContactInfo";

function Contact() {
  return (
    <div className="container mx-auto px-4 py-8">
      <motion.h1
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.5, duration: 0.5 }}
        className="text-4xl font-bold m-4 text-slate-50"
      >
        <FaEnvelope className="m-2 text-slate-50" /> Contact Me
      </motion.h1>
      <ContactForm />
      <ContactInfo />
    </div>
  );
}

export default Contact;
